@layer reset, default, focus;

@layer reset {
  :host {
    display: block;

    .gcds-search input {
      background-image: none;
      box-sizing: border-box;
    }

    [type='search']::-webkit-search-cancel-button,
    [type='search']::-webkit-search-decoration {
      -webkit-appearance: none;
      appearance: none;
    }
  }
}

@layer default {
  :host .gcds-search {
    .gcds-search__header {
      display: block;
      width: 0;
      height: 0;
      margin: 0;
      overflow: hidden;
    }

    .gcds-search__form {
      display: flex;
      margin: var(--gcds-search-margin) !important;
    }

    input {
      box-sizing: border-box;
      border-radius: 0;
      width: 100%;
      max-height: var(--gcds-search-max-height);
      font: var(--gcds-search-font);
      padding: var(--gcds-search-padding) !important;
      background-color: var(--gcds-search-default-background);
      color: var(--gcds-search-default-text);
      border: var(--gcds-search-border-width) solid var(--gcds-search-border-color);
      border-right: 0 solid transparent;
      transition:
        border-color ease-in-out 0.15s,
        box-shadow ease-in-out 0.15s;

      &::placeholder {
        color: var(--gcds-search-placeholder);
      }
    }

    gcds-button {
      --gcds-button-mobile-margin: 0;

      &::part(button) {
        border-radius: 0;
        padding: 0;
        width: var(--gcds-search-button-width-height);
        height: var(--gcds-search-button-width-height);
      }
    }
  }
}

@layer focus {
  :host .gcds-search {
    input:focus {
      border-color: var(--gcds-search-focus-border-color);
      outline: var(--gcds-search-outline-width) solid
        var(--gcds-search-focus-border-color);
      outline-offset: var(--gcds-search-border-width);
      box-shadow: var(--gcds-search-focus-box-shadow);
      border-width: var(--gcds-search-focus-border-width);
      margin: var(--gcds-search-focus-margin);
      z-index: 30;
    }

    ::part(button):focus {
      box-shadow: var(--gcds-search-focus-box-shadow);
    }
  }
}
